/**
 * ExitConfirmationModal Component
 * On-brand confirmation dialog for exiting the tutorial
 */

import { motion, AnimatePresence } from "framer-motion";
import { LogOut } from "lucide-react";

interface ExitConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ExitConfirmationModal({
  isOpen,
  onConfirm,
  onCancel,
}: ExitConfirmationModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[110] flex items-center justify-center">
          <motion.div
            className="absolute inset-0 bg-black/40"
            onClick={onCancel}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          />

          <motion.div
            className="relative z-[111] bg-surface-primary rounded-xl shadow-modal w-full max-w-sm mx-4 p-6"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            <div className="flex justify-center mb-4">
              <div className="p-3 rounded-full bg-warning/10">
                <LogOut className="w-6 h-6 text-warning" />
              </div>
            </div>

            <h3 className="text-headline font-semibold text-content-primary text-center mb-2">
              Exit Tutorial?
            </h3>
            <p className="text-callout text-content-secondary text-center leading-relaxed mb-6">
              Your progress will be saved. You can restart the tutorial anytime
              from the sidebar.
            </p>

            <div className="flex gap-3">
              <button
                onClick={onCancel}
                className="d-btn d-btn-secondary flex-1"
              >
                Continue Tutorial
              </button>
              <button
                onClick={onConfirm}
                className="d-btn d-btn-primary flex-1"
              >
                Exit
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
